import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BlueprintGrid } from "../components/BlueprintGrid";
import { Link } from "react-router-dom";
import { fadeUp, fadeUpSlow, stagger, viewportOnce } from "../lib/motion";

const VisionClosing = () => (
    <section
        data-testid="vision-closing"
        className="relative overflow-hidden bg-surface/40 py-28 lg:py-44"
    >
        <BlueprintGrid className="opacity-40" />
        <div className="relative mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
            >
                <motion.p
                    variants={fadeUp}
                    className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist"
                >
                    <span className="h-1.5 w-1.5 bg-accent" />
                    HOME VISION
                </motion.p>
                <motion.h2
                    variants={fadeUpSlow}
                    data-testid="vision-closing-headline"
                    className="mt-10 max-w-5xl text-4xl font-light leading-[1.1] text-white md:text-6xl lg:text-7xl"
                >
                    Your plan is where the build begins.
                    <span className="block text-mist">
                        Your vision is where it becomes real.
                    </span>
                </motion.h2>
                <motion.div variants={fadeUp} className="mt-14">
                    <Link
                        to="/join-the-pilot"
                        data-testid="vision-join-pilot"
                        className="inline-flex items-center gap-3 bg-accent px-8 py-4 text-[16px] font-semibold tracking-wide text-white transition-colors duration-300 hover:bg-[#ff7026]"
                    >
                        Join the BuildEase Pilot
                        <ArrowUpRight className="h-4 w-4" />
                    </Link>
                </motion.div>
            </motion.div>
        </div>
    </section>
);

export default VisionClosing;
